export interface EntityAcl {
  parentStatus: string
  canDelete: boolean
  canUpdate: boolean
  canDeactivate: boolean
  canActivate: boolean
  sensitiveFields: string[]
  invisibleFields: string[]
  nonWritableFields: string[]
}

export const ACL_DEFAULT: EntityAcl = {
  parentStatus: '',
  canDelete: true,
  canUpdate: true,
  canDeactivate: true,
  canActivate: true,
  sensitiveFields: [],
  invisibleFields: [],
  nonWritableFields: [],
}
